<template>
    <div class="home">
        <Header :hideIpt="true" :color="true" :bannerBg=2></Header>
        <!-- 背景图 -->
        <div class="bg" ref="height1">
            <div class="mask"></div>
            <img v-if="itemData && itemData.info_path" :src="itemData.info_path" alt="Background Image"
                class="background-image" />
        </div>
        <div class="header">
            <h1 class="__line1">{{ itemData.title }}</h1>
            <p class="__line3">{{ itemData.description }}</p>
        </div>
        <div class="rich-text-page notScroll" :style="{ height: emptyHeight + 'px' }">

            <div class="richTitle">产品优势</div>

            <!-- 富文本内容 -->
            <div class="content" v-html="itemData.content"></div>
            <div class="seachProdBox" v-if="itemData.is_show" @click="handleTagClick">
                <span>查看相关产品</span><img class="icon" src="@/assets/images/RightOutline.png" alt="" srcset="">
            </div>
            <div class="products-section" v-show="itemData.label && itemData.label.length > 0">
                <h2>应用领域</h2>
                <div class="product-item" v-for="(item, index) in itemData.label" :key="index" @click="toggleItem(index)">
                    <div class="product-header">
                        <span>{{ item.title || '' }}</span>
                        <img :src="item.isOpen ? require('@/assets/images/reduce.png') : require('@/assets/images/add.png')"
                            alt="Toggle Icon" class="toggle-symbol" />
                    </div>
                    <div v-show="item.isOpen" class="product-content">
                        <img :src="item.path" alt="Product Image" class="product-image" />
                        <div class="product-description">{{ item.description }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width:100%;height:64px"></div>
        <tabBar></tabBar>
    </div>
</template>

<script>
import Header from "@/components/header";
import tabBar from "@/components/tabBar.vue";

export default {
    components: {
        Header,
        tabBar
    },
    data() {
        return {
            emptyHeight: 0,
            itemData: {},
            query: null,
            title: "示例标题",
            time: "2023-10-01",
            richTextContent: `<p>这是一些富文本内容。可以包含<strong>粗体</strong>、<em>斜体</em>、以及其它HTML元素。</p>`,
            products: [
                {
                    title: "产品1",
                    path: "https://lop-oss.oss-cn-beijing.aliyuncs.com/leaderboard/202412/rc-upload-1733539341363-4.png",
                    description: "在的抗紫外稳定性在的抗紫外稳定性在的抗紫外稳定性在的抗紫外稳定性在的抗紫外稳定性在的抗紫外稳定性\n·通过内部的印刷进行品牌定制\n·防滑和防粘连添加剂",
                    isOpen: false,
                },
                {
                    title: "产品2",
                    path: "https://lop-oss.oss-cn-beijing.aliyuncs.com/leaderboard/202412/rc-upload-1733539341363-7.png",
                    description: "在的抗紫外稳定性\n·通过内部的印刷进行品牌定制\n·防滑和防粘连添加剂",
                    isOpen: false,
                },
            ],
        };
    },
    mounted() {
        this.initShare();
        this.query = this.$route.query;
        this.getDisData();
        this.$dataStatistics({
            page_title: `解决方案详情`,
          
        },  '查看解决方案详情');
        this.calculateEmptyHeight();
    },
    methods: {
        async handleTagClick() {
            this.$dataStatistics('click','查看相关产品');
            let list = await this.getTabList();
            let index = list.findIndex(item => this.itemData?.about == item.id);
            this.$router.push(`/childList?tabId=${index}`)
        },
        async getTabList() {
            let params = {
                "filter[type]": 1,
            };
            let res = await this.$http.get("/api/platform/category", { params: params })
            return res.data;

            // this.getChild();
        },
        calculateEmptyHeight() {
            this.$nextTick(() => {
                const bannerHeight = this.$refs.height1.offsetHeight;
                const paddingBox = 79; // Padding value

                // Calculate remaining height
                const remainingHeight =
                    window.innerHeight -
                    bannerHeight -
                    paddingBox;
                this.emptyHeight = remainingHeight > 0 ? remainingHeight : 0;
            });
        },
        getDisData() {
            this.$http
                .get(`/api/platform/area/${this.query.id}`, {})
                .then((res) => {
                    this.itemData = res.data;
                    if (this.itemData.label && Array.isArray(this.itemData.label)) {
                        this.itemData.label.forEach(item => {
                            this.$set(item, 'isOpen', false); // 使用 $set 确保响应性
                        });
                    }
                    console.log('this.itemData.label ---:', this.itemData.label);
                });
        },
        toggleItem(index) {
            if (this.itemData.label && this.itemData.label[index]) {
                const currentState = this.itemData.label[index].isOpen;
                this.$set(this.itemData.label[index], 'isOpen', !currentState);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.home {
    position: relative;
}

.bg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 192px;
    /* 适当设置高度 */
}

.mask {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
}

.background-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.rich-text-page {
    z-index: 22;
    position: absolute;
    top: 180px;
    background-color: #FFFFFF;
    border-radius: 12px 12px 0px 0px;
    max-width: 100%;
    margin: auto;
    padding: 16px 16px 4px;
    width: 100%;
    overflow-y: scroll;

    .richTitle {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: bold;
        margin-bottom: 12px;
    }
}

.header {
    position: absolute;
    top: 70px;
    left: 16px;
    width: 343px;
}

.header h1 {
    font-size: 24px;
    color: #FFFFFF;
    line-height: 36px;
}

.header p {
    color: #FFFFFF;
    line-height: 20px;
    margin-top: 8px;
    font-size: 14px;
}

.products-section {
    margin-top: 16px;
    overflow: auto;
}

.products-section h2 {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    margin-top: 16px;
}

.product-item {
    margin-bottom: 15px;
    border-radius: 5px;
    overflow: hidden;
    margin-top: 16px;
    border-bottom: 1px solid #F3F3F3;
}

.product-header {
    padding: 12px 12px;
    cursor: pointer;
    display: flex;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
}

.toggle-symbol {
    width: 18px;
    height: 18px;
}

.product-content {
    padding: 0 12px;

}

.product-description {
    white-space: pre-wrap;
    font-size: 14px;
    color: #5D5D61;
    line-height: 20px;
    width: 100%;
    margin-bottom: 12px;
}

.product-image {
    width: 100%;
    height: auto;
    margin-bottom: 7px;
    border-radius: 8px 8px 8px 8px;
}

.content {
    ::v-deep li::before {
        content: "• ";
        /* 使用不同的符号 */
        color: #333;
        /* 自定义颜色 */
        font-size: 18px;
        /* 自定义大小 */
    }

    ::v-deep p {
        min-height: 12px;
    }

    ::v-deep video {
        width: 100%;
        height: auto;
    }

    ::v-deep img {
        width: 100%;
        height: auto;
    }

}

.seachProdBox {
    width: 343px;
    height: 36px;
    border-radius: 100px 100px 100px 100px;
    border: 1px solid #0479DA;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #0059A3;
    margin: 12px auto 16px;
    span {
        margin-right: 8px;
        // margin-left: 8px;
    }

    img {
        width: 14px;
        height: 14px;
    }
}</style>